import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3a35025a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/partybox.pl/httpdocs/crazyshop/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a35025a')) {
      api.createRecord('3a35025a', component.options)
    } else {
      api.reload('3a35025a', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=3a35025a&", function () {
      api.rerender('3a35025a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/vue/modules/additional-products/App.vue"
export default component.exports